import { create } from 'zustand';

export type User = {
  id: string;
  name: string;
  email: string;
  role: string;
};

type AuthState = {
  token: string | null;
  user: User | null;
  isLoading: boolean;
  setAuth: (token: string, user: User) => void;
  logout: () => void;
  setLoading: (v: boolean) => void;
};

export const useAuth = create<AuthState>((set) => ({
  token: localStorage.getItem('tialeila_token') || null,
  user: localStorage.getItem('tialeila_user') ? JSON.parse(localStorage.getItem('tialeila_user')!) : null,
  isLoading: false,
  setAuth: (token, user) => {
    localStorage.setItem('tialeila_token', token);
    localStorage.setItem('tialeila_user', JSON.stringify(user));
    set({ token, user });
  },
  logout: () => {
    localStorage.removeItem('tialeila_token');
    localStorage.removeItem('tialeila_user');
    set({ token: null, user: null });
  },
  setLoading: (v) => set({ isLoading: v }),
}));

export const API_URL = import.meta.env.VITE_API_URL || 'https://tialeila1.amadorzona.com/api';

export function Currency(value: number) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);
}

export function DateBR(iso: string | null) {
  if (!iso) return '-';
  return new Date(iso).toLocaleDateString('pt-BR');
}
